<template lang="html">
  <span>
    <b-dropdown
      :id="id"
      ref="dropdown"
      :size="size"
      :variant="variant"
      :disabled="disableButton"
      text="Share"
      right
      class="ml-1"
    >
      <template slot="button-content"> Share <v-icon name="share" /> </template>
      <b-dropdown-text v-if="!show.published" style="width: 240px;">
        <p>{{ stateDescription }}</p>
        <p>
          <b-btn size="sm" @click="gotoPrivacy">
            Edit privacy settings
          </b-btn>
        </p>
      </b-dropdown-text>
      <b-dropdown-divider v-if="!show.published" />
      <b-dropdown-item @click="copyLink">
        Copy link
      </b-dropdown-item>
      <b-dropdown-item @click="copyEmbedCode">
        Copy embed code
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="gotoMode('embed')">
        Embed code options
      </b-dropdown-item>
    </b-dropdown>
    <b-tooltip v-if="disableButton" ref="tooltip" :target="id">
      <v-icon name="exclamation-triangle" /> This show contains features which
      can only be exported to video. Privacy options are limited to private view
      only.
    </b-tooltip>
  </span>
</template>

<script>
import { returnResponsiveEmbedCode } from "@/utils/embedCode";
import { returnShowStateDescription } from "@/utils/embedCode";
import { Show } from "@/models/showModel";
import copy from "copy-to-clipboard";
export default {
  name: "ShareButton",
  props: {
    show: {
      required: true,
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: () => "secondary"
    }
  },
  data() {
    return {
      size: "md"
    };
  },
  computed: {
    id() {
      return (
        "tooltip-" +
        Math.random()
          .toString(36)
          .substring(2, 15)
      );
    },
    readOnlyShowModel() {
      if (this.show) {
        return new Show(this.show);
      }
      return {};
    },
    link() {
      return this.readOnlyShowModel.link;
    },
    isPublishable() {
      return this.readOnlyShowModel.isPublishable;
    },
    stateDescription() {
      return returnShowStateDescription(this.show);
    },
    disableButton() {
      // Disable if show can't be published (motion or video)
      if (!this.isPublishable) {
        return true;
      }
      // Never disable when this component is used from /shows listing.
      if (this.$route.name === "shows") {
        return false;
      }
      return this.$store.getters["show/displayInitialImporter"];
    }
  },
  methods: {
    gotoMode(mode) {
      var key = this.show.key;
      this.$router
        .push({ name: "show-mode", params: { id: key, mode: mode } })
        .catch(() => {});
    },
    gotoPrivacy() {
      this.$refs.dropdown.hide(true);
      this.$router
        .push({
          name: "show-mode-highlight",
          params: { id: this.show.key, mode: "settings", highlight: "privacy" }
        })
        .catch(() => {});
    },
    copyLink() {
      copy(this.link, { format: "text/plain" });
      this.$store.dispatch("toastMessage", "Link copied to clipboard.");
    },
    copyEmbedCode() {
      var embedCode = returnResponsiveEmbedCode(this.show);
      copy(embedCode, { format: "text/plain" });
      this.$store.dispatch("toastMessage", "Embed code copied to clipboard.");
    }
  }
};
</script>

<style lang="css" scoped></style>
